import React from "react";

export default function Info(props) {
  return (
    <div className="info-text">
      <span> {props.field.properties?.text?.nl} </span>
    </div>
  );
}
